module.exports = __webpack_public_path__ + "img/2.ภาคใต้.dd8e6838.jpg";